import { uuidv4 } from '@transsion/utils/generate'

import type { LanguageHolder } from './interfaces'
import type { Env, LangCallback, RequestIdCallback } from './types'

export function normalizeEnv(env?: string): Env {
  if (!env) return 'prod'

  switch (env.toLowerCase()) {
    case 'development':
    case 'dev':
    case 'deving': {
      return 'dev'
    }
    case 'test':
    case 'testing':
    case 'sit':
    case 'siting': {
      return 'sit'
    }
    case 'uat':
    case 'uating':
    case 'staging': {
      return 'uat'
    }
    case 'production':
    case 'prod': {
      return 'prod'
    }
    default: {
      throw new TypeError(`Invalid env: ${env}`)
    }
  }
}

export function normalizeRequestId(requestId?: RequestIdCallback | string): string {
  return typeof requestId === 'function' ? requestId() : (requestId ?? uuidv4())
}

export function normalizeLanguageGetter(
  lang?: string | LangCallback | Partial<Pick<LanguageHolder, 'getLang'>>,
): LangCallback {
  switch (typeof lang) {
    case 'string': {
      return () => lang
    }
    case 'function': {
      return lang
    }
    case 'object': {
      return lang.getLang ?? (() => null)
    }
    default: {
      return () => null
    }
  }
}

export function normalizeLanguageHolder(
  lang?: string | LangCallback | Partial<LanguageHolder>,
): LanguageHolder {
  switch (typeof lang) {
    case 'string':
    case 'function': {
      return {
        getLang: normalizeLanguageGetter(lang),
        setLang: () => true,
      }
    }
    case 'object': {
      return {
        getLang: lang.getLang ?? (() => null),
        setLang: lang.setLang ?? (() => true),
      }
    }
    default: {
      return {
        getLang: () => null,
        setLang: () => true,
      }
    }
  }
}
